import React from 'react';

import { useSoyuzLocales } from '@spotahome/soyuz/client';

import { ExternalLinkProvider } from '../../context/ExternalLink';

import FooterSimplified from './FooterSimplified';

const FooterSimplifiedContainer = () => {
  const { current } = useSoyuzLocales();
  return (
    <ExternalLinkProvider currentLocale={current}>
      <FooterSimplified />
    </ExternalLinkProvider>
  );
};

export default FooterSimplifiedContainer;
